export interface FilterParams {
  headerName: string;
  columnField: string;
  type: "categorical" | "textfield" | "date" | "multiselect";
  typeText?: "string" | "number";
  operatorOptions?: Array<{
    value: string;
    name: string;
  }>;
  valueOptions?: Array<{
    value: string;
    name: string;
    suffix?: string;
  }>;
}

const inspectionResultOptions = [
  { value: "OPEN", name: "Open" },
  { value: "FAIL", name: "Fail" },
  { value: "PASS", name: "Pass" },
  { value: "NEEDS_REVIEW", name: "Needs review" },
  { value: "NO_POSICHECKS", name: "No Posichecks" },
];

const strOptions = [
  { value: "yes", name: "Yes" },
  { value: "no", name: "No" },
  { value: "unclear", name: "Unclear" },
  { value: "answered", name: "Yes or No" },
];

const opOptions = [
  { value: "=", name: "Equals" },
  { value: "!=", name: "Does not equal" },
  { value: "<", name: "Is less than" },
  { value: ">", name: "Is greater Than" },
];

export const dateValues = ["1h", "24h", "7d", "4w", "custom"];

export const inspectionsfiltersData: FilterParams[] = [
  {
    headerName: "Inspection ID",
    columnField: "id",
    type: "textfield",
    typeText: "string",
    operatorOptions: [opOptions[0], opOptions[1]],
  },
  {
    headerName: "Timestamp",
    columnField: "date",
    type: "date",
    valueOptions: [
      { name: "Last 1hr", value: "1h" },
      { name: "Last 24hrs", value: "24h" },
      { name: "Last 7 days", value: "7d" },
      { name: "Last 30 days", value: "30d" },
      { name: "Custom Range", value: "custom" },
    ],
  },
  {
    headerName: "Result",
    columnField: "result",
    type: "categorical",
    operatorOptions: [opOptions[0]],
    valueOptions: inspectionResultOptions,
  },
  {
    headerName: "PDF Report?",
    columnField: "report_key",
    type: "categorical",
    valueOptions: [strOptions[0], strOptions[1]],
    operatorOptions: [opOptions[0]],
  },
];
